export default function DisputeReportModal({
  open,
  disputeReason,
  disputeComment,
  disputePhotos,
  processingDispute,
  onReasonChange,
  onCommentChange,
  onPhotoUpload,
  onSubmit,
  onClose,
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="dispute-modal">
        <div className="modal-header">
          <h3>🚨 Report Issue</h3>
          <button type="button" onClick={onClose} className="close-btn">✕</button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="disputeReason">Issue Type *</label>
            <select
              id="disputeReason"
              value={disputeReason}
              onChange={(e) => onReasonChange(e.target.value)}
              className="dispute-select"
              required
            >
              <option value="">Select an issue type...</option>
              <option value="damaged_product">📦 Damaged Product</option>
              <option value="wrong_item">🔄 Wrong Item Sent</option>
              <option value="not_as_described">❌ Not as Described</option>
              <option value="missing_items">📋 Missing Items</option>
              <option value="quality_issues">⚠️ Quality Issues</option>
              <option value="defective">🔧 Defective Product</option>
              <option value="other">❓ Other Issue</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="disputeComment">Describe the Issue *</label>
            <textarea
              id="disputeComment"
              value={disputeComment}
              onChange={(e) => onCommentChange(e.target.value)}
              placeholder="Please describe the issue in detail. This will help us resolve it quickly..."
              className="dispute-textarea"
              rows="4"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="disputePhotos">Upload Photos (Optional)</label>
            <input
              type="file"
              id="disputePhotos"
              multiple
              accept="image/*"
              onChange={onPhotoUpload}
              className="photo-input"
            />
            <div className="photo-info">
              <small>📸 Upload up to 5 photos (max 5MB each) to help us understand the issue</small>
            </div>
            {disputePhotos.length > 0 && (
              <div className="uploaded-photos">
                <strong>Selected Photos:</strong>
                <ul>
                  {disputePhotos.map((file, index) => (
                    <li key={index}>{file.name} ({(file.size / 1024 / 1024).toFixed(2)}MB)</li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="dispute-info-box">
            <h4>🔔 What happens next?</h4>
            <ul>
              <li>✅ We&apos;ll review your dispute within 24 hours</li>
              <li>📧 You&apos;ll receive an email confirmation</li>
              <li>🔄 We&apos;ll offer either a refund or reorder</li>
              <li>💬 Our team may contact you for additional details</li>
            </ul>
          </div>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={onSubmit}
            disabled={processingDispute || !disputeReason.trim() || !disputeComment.trim()}
            className="submit-dispute-btn"
          >
            {processingDispute ? '⏳ Submitting...' : '🚨 Submit Dispute'}
          </button>
          <button type="button" onClick={onClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
